module.exports = __webpack_public_path__ + "static/media/eye.0c816205.svg";